import { getTokenCookie } from '@/utils/auth';
import type { RequestConfig, RequestOptions } from '@umijs/max';
import { message } from 'antd';

const requestConfig: RequestConfig = {
  // 请求拦截器
  requestInterceptors: [
    (config: RequestOptions) => {
      if (getTokenCookie()) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${getTokenCookie()}`,
        };
      }
      return config;
    },
  ],
  // 响应拦截器
  responseInterceptors: [
    [
      (response: any) => {
        if (response.data.code === 0) {
          return response;
        }

        message.error(response.data.message);
        return Promise.reject(response.data.message);
      },
      (error: any) => {
        const statusMessageMap = {
          401: '登录过期，请重新登录',
          403: '无权限操作',
          404: '请求资源不存在',
          500: '服务器错误',
        };

        if (error.response.status >= 400 && error.response.status < 600) {
          const errorMessage: string =
            statusMessageMap[
              error.response.status as keyof typeof statusMessageMap
            ] || '服务出小差，请稍后再试';
          message.error(errorMessage);
        }

        return Promise.reject(error);
      },
    ],
  ],
};

export default requestConfig;
